import { render, staticRenderFns } from "./createDriver.vue?vue&type=template&id=1b51b654&"
import script from "./createDriver.vue?vue&type=script&lang=js&"
export * from "./createDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports